import { Logger, LoggerFactory } from './../logger.service';
import { Environment } from './../../environment/environment.base';

export class AmplitudeService implements IAmplitude {
  private readonly logger: Logger;

  constructor(
    private readonly environment: Environment,
    loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('AmplitudeService');
  }

  public logEvent(eventName: string): void {
    const amplitude = (<any>window).amplitude;
    if (amplitude) {
      amplitude.getInstance().logEvent(eventName);
    } else {
      this.logger.info(`Amplitude not defined. Should have logged event: ${eventName}`);
    }
  }
}

export interface IAmplitude {
  logEvent(eventName: string): void;
}
